<script setup lang="ts">
import PreviewPdf from './pdf.vue';
import PreviewImage from './image.vue';

const props = defineProps<{
  url: string,
  ext?: string,
}>();
const isError = defineModel<boolean>('isError');
const pdfExtensions = ['pdf', 'PDF', 'Pdf'];
</script>

<template>
  <PreviewPdf
    v-if="props.ext && pdfExtensions.includes(props.ext)"
    v-model:is-error="isError"
    :url="url"
  />
  <PreviewImage
    v-else
    v-model:is-error="isError"
    :url="url"
  />
</template>
